import axios from 'axios';

import { CONFIGURACION_PERFIL, CONFIGURACION_REGIMENES_FISCALES, CONFIGURACION_GIROS, CONFIGURACION_MEMBRESIAS, CONFIGURACION_METODO_PAGO } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Regimenes fiscales */
export const buscarRegimenesFiscalesConfiguracion = (tipo_persona) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        tipo_persona
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_regimenes_fiscales`, body, config);

        await dispatch({
            type: CONFIGURACION_REGIMENES_FISCALES.BUSCAR,
            payload: res.data.regimenes
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Giros */
export const buscarGirosConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_giros`, config);

        await dispatch({
            type: CONFIGURACION_GIROS.BUSCAR,
            payload: res.data.giros
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Membresias */
export const buscarMembresiasConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_membresias`, config);

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.BUSCAR,
            payload: res.data.membresias
        });
    } catch (error){ 
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Perfil */
export const obtenerPerfilPersonal = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/obtener_perfil_personal`, config);

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_PERSONAL,
            payload: res.data.perfil
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const guardarPerfilPersonal = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_perfil_personal`, perfil, config);

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_PERSONAL,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerPerfilEmpresarial = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/obtener_perfil_empresarial`, config);

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_EMPRESARIAL,
            payload: res.data.perfil
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const guardarPerfilEmpresarial = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_perfil_empresarial`, perfil, config);

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_EMPRESARIAL,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Método de pago */
export const obtenerMetodoPago = () => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodo_pago`, config);

        await dispatch({
            type: CONFIGURACION_METODO_PAGO.OBTENER,
            payload: res.data.tarjeta
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const actualizarMetodoPago = (payment_method_id) => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = JSON.stringify({ payment_method_id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodo_pago`, body, config);

        await dispatch({
            type: CONFIGURACION_METODO_PAGO.ACTUALIZAR,
            payload: res.data.tarjeta
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarMetodoPago = () => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_metodo_pago`, {}, config);

        await dispatch({
            type: CONFIGURACION_METODO_PAGO.ELIMINAR,
            payload: null
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};
